import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";

import { baseFilterOrders } from "./orders_sale_constants";
import classes from "../purchase.module.scss";

import { useOrderSalePaginate } from "@/hooks/purchases/orders_sale";
import { hasPermission } from "@/services/Utils";

import Head from "@/components/Content/Head";
import Fetching from "@/components/Fetching/Fetching";
import ButtonFilter from "@/components/Filter/ButtonFilter";
import BasePagination from "@/components/Pagination/BasePagination";
import ProductPending from "@/components/Product/ProductPending/ProductPending";

import OrdersSaleAction from "./Table/Action/OrdersSaleAction";
import OrdersSaleActionSelect from "./Table/Action/OrdersSaleActionSelect";
import OrdersSaleTable from "./Table/OrdersSaleTable";
import OrdersFilter from "./OrdersSaleFilter";
import IntegrationLoad from "../Integration/IntegrationLoad";

const OrdersSale = () => {
	const { filter } = useSelector((state) => state.auth);
	const { estate_parent_id, estate_id, type_currency, search, parameter } = filter;

	const [data, setData] = useState([]);
	const [base, setBase] = useState({
		...baseFilterOrders,
		estate_parent_id,
		estate_id,
		type_currency,
		search,
		parameter,
	});
	const [showFilter, setShowFilter] = useState(false);
	const [integrationSelect, setIntegrationSelect] = useState({
		show: false,
		name: "",
		integration: "",
		file: null,
	});

	const { data: response, isLoading: loading, isFetching } = useOrderSalePaginate(base);

	const { list, titles, permissions } = response ? response : {};
	const { last_page, total, from, to } = list ? list : {};

	useEffect(() => {
		if (list) {
			setData(list.data);
		}
		setBase({ ...base, estate_parent_id, estate_id, type_currency, search, parameter });
		// eslint-disable-next-line
	}, [list, estate_parent_id, estate_id, search, parameter, type_currency]);

	const setPage = (value) => setBase({ ...base, page: value });
	const setPaginate = (value) => setBase({ ...base, paginate: value });

	const applyFilter = (params) => {
		let newBase = { ...base };

		if (params.purchaseOrderSaleFilter !== base.purchaseOrderSaleFilter) {
			newBase = {
				...base,
				purchaseOrderSaleFilter: params.purchaseOrderSaleFilter,
			};
		}

		if (params.defaultUnitFilter !== base.defaultUnitFilter) {
			newBase = {
				...base,
				defaultUnitFilter: params.defaultUnitFilter,
			};
		}

		if (params.purchaseClassFilter !== base.purchaseClassFilter) {
			newBase = {
				...base,
				purchaseClassFilter: params.purchaseClassFilter,
			};
		}

		if (params.purchaseStateFilter !== base.purchaseStateFilter) {
			newBase = {
				...base,
				purchaseStateFilter: params.purchaseStateFilter,
			};
		}

		if (params.dateFilter !== base.dateFilter) {
			newBase = {
				...base,
				dateFilter: params.dateFilter,
			};
		}

		if (params.dateToFilter !== base.dateToFilter) {
			newBase = {
				...base,
				dateToFilter: params.dateToFilter,
			};
		}

		setBase(newBase);
		setShowFilter(false);
	};

	if (loading) {
		return <Fetching />;
	}

	return (
		<>
			<Head title={"Compras"} titles={titles} isFetching={isFetching} />

			<ButtonFilter origin="main" size_md={12} showFilter={showFilter} setShowFilter={setShowFilter} />

			<ProductPending />

			<Row className={classes.purchase_global}>
				{showFilter && <OrdersFilter applyFilter={applyFilter} filters={base} />}
				<Col md={showFilter ? 10 : 12} className={classes.purchase_content}>
					<OrdersSaleAction showFilter={showFilter} setShowFilter={setShowFilter} filters={base} setIntegrationSelect={setIntegrationSelect} />

					{data && data.filter((d) => d.selected).length !== 0 && <OrdersSaleActionSelect />}

					{hasPermission("show", permissions) && <OrdersSaleTable data={data} setData={setData} base={base} setBase={setBase} />}

					<BasePagination
						page={base.page}
						paginate={base.paginate}
						last_page={last_page}
						quantity={total}
						from={from}
						to={to}
						setPage={setPage}
						setPaginate={setPaginate}
					/>
				</Col>
			</Row>

			<IntegrationLoad integrationSelect={integrationSelect} />
		</>
	);
};

export default OrdersSale;
